export default "__VITE_ASSET__BX21zuen__"